<template>
  <!-- Progress bar pri navigácii -->
  <PageLoader />

  <!-- Bez mode="out-in" — nová stránka vstupuje okamžite, obsah sa vždy zobrazí -->
  <router-view v-slot="{ Component }">
    <transition name="page-fade">
      <component :is="Component" :key="$route.matched[0]?.path" />
    </transition>
  </router-view>
</template>

<script>
import PageLoader from './components/PageLoader.vue';

export default {
  components: { PageLoader },
};
</script>